import { all } from "redux-saga/effects";


import alertSaga from "./alert";
import clientSaga from "./client";
import contractorSaga from "./contractor";
import cordovaSaga from './cordova';
import djrSaga from "./djr";
import errorSaga from './error';
import holidaySaga from "./holiday";
import leaveSaga from "./leave";
import notificationsSaga from "./notifications";
import officeAssignmentSaga from "./officeAssignments";
import progressSaga from './progress';
import projectSaga from "./project";
import reportSaga from './report';
import subContractorSaga from "./subContractor";
import taskSaga from "./task";
import teamSaga from './team';
import userSaga from './user';

export default function* rootSaga() {
    yield all([
        cordovaSaga(),
        errorSaga(),
        progressSaga(),
        userSaga(),
        notificationsSaga(),
        djrSaga(),
        clientSaga(),
        subContractorSaga(),
        projectSaga(),
        contractorSaga(),
        taskSaga(),
        alertSaga(),
        holidaySaga(),
        leaveSaga(),
        officeAssignmentSaga(),
        reportSaga(),
        teamSaga()
    ]);
}
